import { useState } from "react";
import {
  CForm,
  CFormLabel,
  CFormInput,
  CFormTextarea,
  CButton,
  CRow,
  CCol
} from '@coreui/react';
import { cilX } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import AxiosInstance from "../Axios";
import { transliterate } from 'transliteration';

const ModelsObjectEditNew = ({ toastifySuccess, data, actionShowModal, parentId, getModelObjects }) => {
  
  const [type, setType] = useState((data !== null && data.type) ? data.type : 'Sketchfab');
  const [sort, setSort] = useState((data !== null && data.sort) ? data.sort : 0);
  const [year, setYear] = useState((data !== null && data.year) ? data.year : new Date().getFullYear());
  const [embedCode, setEmbedCode] = useState((data !== null && data.data) ? data.data : '');
  const [isCreate, setIsCreate] = useState(false);
  const [modelId, setModelId] = useState(data?.id !== undefined ? data.id : 0);

  const handleSubmit = event => {
    event.preventDefault();
    if(modelId) {
      updateModel(modelId);
    }
    else {
      createModel(parentId, false);
    }
  };

  const handleCancel = () => {
    actionShowModal(false);
  };

  async function createModel(id, show){
    setIsCreate(true);
    return AxiosInstance.post('/models', {
      "data": embedCode,
      "sort": sort === '' ? 0 : sort,
      "type": type,
      "year": year === '' ? new Date().getFullYear() : year,
      "object": `/api/objects/${id}`
    }).then((response)=>{
      getModelObjects();
      !show && toastifySuccess('Модель створено');
      return response;
    }).catch(() => {
      toastifySuccess('Помилка при створені моделі');
    }).finally(()=>{
      actionShowModal(show); 
      setIsCreate(false);
    })
  }
  

  function updateModel(id) {
    setIsCreate(true);
    AxiosInstance.put(`/models/${id}`, {
      "data": embedCode,
      "sort": sort === '' ? 0 : sort,
      "type": type,
      "year": year === '' ? new Date().getFullYear() : year
    }).then(()=>{
      getModelObjects();
      toastifySuccess('Модель оновлено');
    }).catch(() => {
      toastifySuccess('Помилка при оновлені моделі');
    }).finally(()=>{
      actionShowModal(false);
      setIsCreate(false);
    })
  }

  function createFtpDir(id, type){
    const formatType = transliterate(type).toLowerCase().replace(/ /g, '_');
    AxiosInstance.get(`/create-dir-ftp?models_id=${id}&type=${formatType}`).then(response => {
      const data = response.data;
      if (data?.url !== undefined) {
        const ftpIp = process.env.REACT_APP_FTP_IP  || false;
        const ftpUser = process.env.REACT_APP_FTP_USER || false;
        if (!ftpIp || !ftpUser) {
          toastifySuccess("FTP не вказані доступи в .env файлі");
          return;
        }
        const ftp = 'winscp-ftp://' + ftpUser + '@' + ftpIp + '/objects' + data.url + '/';
        window.open(ftp, '_blank', 'noopener,noreferrer');
      }
    }).catch(() => {
      toastifySuccess("Помилка створення директорії");
    })
  }

  function handleFTP(){
    // якщо вже існує айдішка
    if(modelId) {
      createFtpDir(modelId, type);
    }
    // якщо відкрили на створення нової моделі то спочатку створюємо моделіь потім фтп
    else {
      createModel(parentId, true).then((response)=>{
        const newId = response?.data?.id;
        setModelId(newId);
        if (newId) {
          createFtpDir(newId, type);
        }
      });
    }
  }

  // Функція для рендерингу прев'ю
  const renderPreview = () => {
    if (!embedCode || embedCode.trim() === '') {
      return (
        <div className="models-preview">
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>
            <img src='/models-template.svg' alt='model-template' />
          </div>
          <div style={{ fontSize: '14px' }}>No preview available</div>
        </div>
      );
    }

    // відобразити embed code як HTML
    return (
      <>
        {(type === 'Nira' || type === 'Sketchfab') && 
        <div 
          className="models-embeded"
          dangerouslySetInnerHTML={{ __html: embedCode }}
        />}
        {(type === 'Deep Explore' || type === 'Point Cloud') && 
          <iframe
            className="models-embeded" 
            src={process.env.REACT_APP_FTP_URL + embedCode} 
            title={type} 
            allowFullScreen 
          />
        }
      </>
    );
  };

  return (
    <div style={{ position: 'relative' }}>
      <CButton
        type="button"
        color="black"
        onClick={handleCancel}
        style={{
          position: 'absolute',
          top: '-50px',
          right: '24px',
          zIndex: 10,
          padding: '4px 8px',
          minWidth: 'auto'
        }}
        title="Закрити"
      >
        <CIcon icon={cilX} size="lg" />
      </CButton>
      <CForm onSubmit={handleSubmit} className="mt-3">
        <div className="models-edit-form">
        <CRow className="align-items-end">
        <CCol xs={12} md={6}>
          <div className="mb-3">
            <CFormLabel>Type</CFormLabel>
            <div className="mb-3 models-edit-form-buttons-type">
              <CButton
                color="secondary"
                onClick={() => setType('Sketchfab')}
                style={{ 
                  flex: 1,
                  backgroundColor: type === 'Sketchfab' ? '#FFFFFF' : '#f7f7f8',
                  borderColor: type === 'Sketchfab' ? '#DADADD' : 'transparent',
                  color: type === 'Sketchfab' ? '#434349' : '#6c757d'
                }}
              >
                Sketchfab
              </CButton>
              <CButton
                color="secondary"
                onClick={() => setType('Nira')}
                style={{ 
                  flex: 1,
                  backgroundColor: type === 'Nira' ? '#FFFFFF' : '#f7f7f8',
                  borderColor: type === 'Nira' ? '#DADADD' : 'transparent',
                  color: type === 'Nira' ? '#434349' : '#6c757d'
                }}
              >
                Nira
              </CButton>
              <CButton
                color="secondary"
                onClick={() => setType('Deep Explore')}
                style={{ 
                  flex: 1,
                  flexGrow: 1.5,
                  backgroundColor: type === 'Deep Explore' ? '#FFFFFF' : '#f7f7f8',
                  borderColor: type === 'Deep Explore' ? '#DADADD' : 'transparent',
                  color: type === 'Deep Explore' ? '#434349' : '#6c757d'
                }}
              >
                Deep Explore
              </CButton>
              <CButton
                color="secondary"
                onClick={() => setType('Point Cloud')}
                style={{ 
                  flex: 1,
                  flexGrow: 1.5,
                  backgroundColor: type === 'Point Cloud' ? '#FFFFFF' : '#f7f7f8',
                  borderColor: type === 'Point Cloud' ? '#DADADD' : 'transparent',
                  color: type === 'Point Cloud' ? '#434349' : '#6c757d'
                }}
              >
                Point Cloud
              </CButton>
            </div>
            <div className="mb-3">
              <CFormLabel htmlFor="exampleFormControlInput1">Сортування</CFormLabel>
              <CFormInput type="number" id="exampleFormControlInput1" value={sort} onChange={(e) => setSort(parseInt(e.target.value) || '')} />
            </div>
          </div>
          <div className="mb-3" style={{minHeight: '333px'}}>
            {(type === 'Deep Explore' || type === 'Point Cloud') ? (
              <>
                <CFormLabel>Upload</CFormLabel>
                <div className="models-upload-banner">
                  <img src="/models-template.svg" alt="FTP upload" className="models-upload-img" />
                  <div className="models-upload-text">
                    <div className="models-upload-title" onClick={handleFTP}>
                      Launch FTP client <br/> for Gaussian Splatting upload
                    </div>
                    <a className="models-upload-subtitle" href="/instructions" target="_blank">
                    <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#fff" d="M549.7 124.1C543.5 100.4 524.9 81.8 501.4 75.5 458.9 64 288.1 64 288.1 64S117.3 64 74.7 75.5C51.2 81.8 32.7 100.4 26.4 124.1 15 167 15 256.4 15 256.4s0 89.4 11.4 132.3c6.3 23.6 24.8 41.5 48.3 47.8 42.6 11.5 213.4 11.5 213.4 11.5s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zM232.2 337.6l0-162.4 142.7 81.2-142.7 81.2z"/></svg>
                      Video instruction: How to use FTP
                    </a>
                  </div>
                </div>
                <div className="mt-3">
                  <CFormLabel htmlFor="embedCodeFtp">And paste link from FTP server</CFormLabel>
                  <CFormInput
                    id="embedCodeFtp"
                    value={embedCode}
                    onChange={(e) => setEmbedCode(e.target.value)}
                    placeholder="ftp://server/path/to/model"
                  />
                </div>
              </>
            ) : (
              <>
                <CFormLabel htmlFor="embedCode">Embed code</CFormLabel>
                <CFormTextarea
                  id="embedCode"
                  value={embedCode}
                  onChange={(e) => setEmbedCode(e.target.value)}
                  placeholder="Paste code here..."
                  rows={10}
                  style={{ resize: 'both', minHeight: '300px', maxWidth: '494px' }}
                />
              </>
            )}
          </div>
        </CCol>
        <CCol xs={12} md={6}>
            <div className="mb-3">
              <CFormLabel htmlFor="modelYearInput">Рік</CFormLabel>
              <CFormInput type="number" id="modelYearInput" value={year} onChange={(e) => setYear(parseInt(e.target.value) || '')} />
            </div>
          <div className="mb-3">
            <CFormLabel>Preview</CFormLabel>
            {renderPreview()}
          </div>
        </CCol>
      </CRow>
      </div>
      <div className="models-edit-form-buttons">
        <CButton
          type="button"
          color="secondary"
          variant="outline"
          onClick={handleCancel}
        >
          Скасувати
        </CButton>
        <CButton type="submit" color="success" className='item_add_button' disabled={isCreate}>
          {isCreate ? "Збереження..." : "Зберегти"}
        </CButton>
      </div>
    </CForm>
    </div>
  );
}

export default ModelsObjectEditNew;
